<template>
  <a name="sustainability"></a>
  <div class="hero-container">
    <!-- Camada de fundo com a imagem e efeito parallax -->
    <div class="hero-background"></div>

    <!-- Camada de sobreposição preta com 50% de transparência -->
    <div class="overlay"></div>

    <!-- Conteúdo do programa -->
    <div class="hero-content">
      <div class="row">
        <div class="col-12 amarelo left">
          <h1 class="azul">Sustainability</h1>
          <br><br><br><br>
        </div>

        <div class="col-4 amarelo border-esq">
          <div class="f-4"><b>For us, sustainability is not just an idea — it’s truly a way of life.</b></div>
          <div class="f-5"><br>Everything at AWA is carefully designed to minimize environmental impact, with a deep respect for nature.</div>
        </div>

        <div class="col-4 amarelo border-esq">
          <div class="f-4"><b>Abundant Source of Pure Water</b></div>
          <div class="f-5">In the Amazon Rainforest, the air is rich in humidity, thanks to the tireless work of trees that pump thousands of liters of water from the soil to the atmosphere every day.</div>
        </div>

        <div class="col-4 amarelo border-esq">
          <div class="f-4"><b>Solar Energy</b></div>
          <div class="f-5">From 2027 onwards, our production process will transition to using 100% solar energy, an abundant and infinite resource.</div>
        </div>

        <div class="col-4 amarelo border-esq">
          <div class="f-4"><b>Glass Bottles</b></div>
          <div class="f-5">Glass is a 100% recyclable material, and our bottles are made with 8% recycled material. Additionally, 20% of the energy used in the production of our bottles comes from gas collected from landfills.</div>
        </div>

        <div class="col-4 amarelo border-esq">
          <div class="f-4"><b>Aluminum Caps</b></div>
          <div class="f-5">Aluminum is a 100% recyclable material, and our caps are designed to be infinitely recyclable. This ensures minimal environmental impact, contributing to a circular economy.</div>
        </div>

        <div class="col-4 amarelo border-esq">
          <div class="f-4"><b>Carbon Negative</b></div>
          <div class="f-5">AWA goes beyond carbon neutral by neutralizing emissions twice using carbon credits from protected reserves in Acre, Brazil, benefiting 17,000 families. Our product is shipped globally on a carbon-negative basis.</div>
        </div>

        <div class="col-4 amarelo border-esq">
          <div class="f-4"><b>No Plastic</b></div>
          <div class="f-5">Our production process ensures the complete absence of plastic, utilizing only sustainable materials throughout. This commitment helps reduce waste and supports a cleaner and greener future.</div>
        </div>

        <div class="col-4 amarelo border-esq">
          <div class="f-4"><b>Tree Planting</b></div>
          <div class="f-5">In commitment to the environment, we ensure that for each 12 bottles sold, one tree is planted in deforested areas, encouraging biodiversity by planting new life in degraded forests and promoting the health of our ecosystem.</div>
        </div>


        <div class="col-4 amarelo border-esq">
          <div class="f-4"><b>Commitment to the Community</b></div>
          <div class="f-5">We are committed to promoting access to clean water, empowering communities to manage sustainable water resources, and supporting education as a key to the future.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
.hero-container {
  position: relative;
  width: 100%;
  min-height: 100vh; /* Garante que o fundo ocupe toda a altura da tela ou mais */
  overflow: hidden; /* Impede que o conteúdo saia da tela */
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%; /* Garante que o fundo ocupe o tamanho da seção */
  background: url('@/assets/bg04.jpg') no-repeat center center/cover;
  background-attachment: fixed; /* Efeito parallax */
  background-size: cover; /* Garantir que a imagem cubra toda a área */
  z-index: -2; /* Coloca o fundo atrás da camada preta e do conteúdo */
}

/* Camada preta com 50% de transparência */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 50% de transparência */
  z-index: -1; /* Coloca a camada preta acima do fundo, mas abaixo do conteúdo */
}

/* Estilos de conteúdo */
.hero-content {
  position: relative;
  z-index: 2; /* Coloca o conteúdo acima do fundo e da camada preta */
  padding: 1rem;
  margin-left: 1rem;
  color: white;
}

/* Estilos para texto */
.f-4 {
  font-size: 2.2rem;
  letter-spacing: 0.06rem;
  line-height: 2.8rem;
  margin-bottom: 0.4rem;
}

.f-5 {
  font-size: 2.1rem;
  letter-spacing: 0.06rem;
  line-height: 2.8rem;
}

.border-esq {
  border-left: 2px solid var(--cream);
  padding: 4rem;
  text-align: left;
}

.row {
  margin: 3rem 5%;
  padding: 2rem 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.col-4 {
  flex: 0 0 32%;
  margin-bottom: 4rem;
}

h1 {
  font-family: var(--object-sans);
  font-size: 5rem;
  font-weight: 400;
  letter-spacing: 0.06rem;
}

/* Ajuste para telas pequenas (mobile) */
@media (max-width: 640px) {
  .f-4 {
    font-size: 2.2rem;
    letter-spacing: 0.06rem;
    line-height: 2.8rem;
    margin-bottom: 2rem;
  }

  .f-5 {
    font-size: 1.25em;
    letter-spacing: 0.06rem;
    line-height: 3.2rem;
  }

  .hero-content {
    position: relative;
    z-index: 2;
    padding: 0rem;
    margin-left: 0rem;
    color: white;
  }

  h1 {
    font-family: var(--object-sans);
    font-size: 4rem;
    font-weight: 400;
    letter-spacing: 0.06rem;
  }

  .row {
    flex-direction: column;
  }

  .col-4 {
    flex: 0 0 100%;
    margin-bottom: 5rem;
    padding-left: 1rem;
  }

  .border-esq {
    border-left: 0;
  }
}

</style>
